import classnames from 'classnames';
import React from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { useRotateCursor } from '@/utils/cursor-kit';

interface IRotateProps {
    rotate: number;
    scale: number;
}

const RotateAction: React.FC<IRotateProps> = React.memo(({ rotate }) => {
    const cursor = useRotateCursor(rotate);

    return (
        <div className={classnames('l-operate__rotate', cursor.cursor)} data-operate-type="image-rotate">
            <div className="l-operate__none-event rotate-icon">
                <IconFont fontSize={14} name="RefreshBold" />
            </div>
        </div>
    );
});

export default RotateAction;
